var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.canSend)?_c('a-button',{on:{"click":_vm.getCode}},[_vm._v(" 获取验证码")]):_c('a-button',{attrs:{"disabled":""}},[_vm._v(_vm._s(_vm.count)+"s后可再次发送")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }